import { useAuthContext } from "@/context/auth-context";
import { Navigate } from "@tanstack/react-router";

export default function LandingPage() {
  const { token, isLoading } = useAuthContext();

  if (isLoading) {
    return null;
  }

  if (token) {
    return <Navigate to="/u/workspaces" replace />;
  }

  return <Navigate to="/u/login" replace />;
}
